import { Component, OnInit } from '@angular/core';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { SimpleNotificationComponent } from '../simple-notification/simple-notification.component';
import { ToastrService, ToastPackage } from 'ngx-toastr';
import { WorkspaceServiceService } from '../../services/workspace-service.service';

@Component({
  selector: '[mobile-simple-notification]',
  template: require('./mobile-simple-notification.component.html'),
  styles: [require('./mobile-simple-notification.component.css')],
  animations: [
    trigger('flyInOut', [
        state('inactive', style({
            
            opacity: 0
        })),
        state('active', style({ opacity: 100 })),
        state('removed', style({ opacity: 0 })),
        transition('inactive => active', animate('{{ easeTime }}ms {{ easing }}')),
        transition('active => removed', animate('{{ easeTime }}ms {{ easing }}'))
      ])],
  preserveWhitespaces: false,
})
export class MobileSimpleNotificationComponent extends SimpleNotificationComponent implements OnInit {
  footerHeight: string | undefined;
 
  get horizontal()
  {
    return this.workspaceService.data.horizontalMode;
  }
  constructor(protected toastrService: ToastrService, public toastPackage: ToastPackage, public workspaceService: WorkspaceServiceService)  { super(toastrService, toastPackage) }

  ngOnInit() {
  }

}
